var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full max-w-md border border-gray-300 bg-blue-50 p-3 rounded-md"},[_c('div',{staticClass:"mb-6 text-lg md:text-xl font-bold text-left w-full"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }